import type { Element } from "React";
type Props = {
  className?: string;
};

const IconDollar = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="#ABABAB" fillRule="nonzero">
      <path
        stroke="#ABABAB"
        strokeWidth=".25"
        d="M8 2a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6zm0 11.333A5.333 5.333 0 1 1 8 2.667a5.333 5.333 0 0 1 0 10.666z"
      />
      <path d="M8 5.37c.783 0 1.445.493 1.445 1.076h.96c0-.984-.828-1.807-1.924-1.996V3.333H7.52V4.45c-1.097.19-1.925 1.012-1.925 1.996 0 1.001.774 1.683 2.3 2.025 1.55.348 1.55.905 1.55 1.089 0 .583-.662 1.075-1.445 1.075s-1.445-.492-1.445-1.075h-.96c0 .983.828 1.806 1.925 1.995v1.112h.96v-1.112c1.097-.19 1.925-1.012 1.925-1.995 0-1.002-.774-1.683-2.3-2.026-1.55-.348-1.55-.905-1.55-1.088 0-.583.662-1.076 1.445-1.076z" />
    </g>
  </svg>
);

export default IconDollar;
